module.exports = __webpack_public_path__ + "img/desburocratizacao_bronze.23c27b2d.png";